const placements = {
    firestorePath: '/placements',
    firestoreRefType: 'collection',
    moduleName: 'placements',
    statePropName: 'placements',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state: {
        placements: null,
    },
    getters: {
        getPlacements: state => {
            return _.toArray(state.placements);
        },
        getPlacementsFromCustomer: (state, getters) => (id) => {
            if (!id) {
                return getters.getPlacements
            }
            let placementsFiltered = _.filter(getters.getPlacements, (p) => {
                let startDate = moment(p.startDate)
                let today = moment()
                let endDate = p.endDate ? moment(p.endDate) : null
                if(startDate.isSameOrBefore(today) && (!endDate || endDate.isAfter(today)) &&  p.customerId === id) {
                    return true
                }
            });

            return placementsFiltered
        },

        getCandidatePlacements: (state, getters) => (id) => {
            let candidatePlacements =  _.filter(getters.getPlacements, ['candidateId', id]);
            return _.orderBy(candidatePlacements, ['startDate'], ['desc']);
        },

        getCustomerPlacements: (state, getters) => (id) => {
            let customerPlacements =  _.filter(getters.getPlacements, ['customerId', id]);
            return _.orderBy(customerPlacements, ['startDate'], ['desc']);
        },

        getActivePlacements: (state, getters) => {
            let openEndDate = _.filter(getters.getPlacements, (p) => {
                let startDate = moment(p.startDate)
                let today = moment()
                let endDate = p.endDate ? moment(p.endDate) : null
                if(startDate.isSameOrBefore(today) && (!endDate || endDate.isAfter(today))) {
                    return true
                }
            })
            return openEndDate.length
        },

        getLastWeekPlacements: (state) => {
            let placements = _.toArray(state.placements);

            let thisMonth = _.filter(placements, function(placement){
                let currentDate = moment(new Date()).format("W-YYYY");
                let placementDate = moment(placement.created_at).format("W-YYYY");
                if (currentDate === placementDate) {
                    return placement
                }
            })
            return thisMonth.length;
        },


    },
    mutations: {},
    actions: {
        setPlacements: payload => {
            payload.commit('setPlacements')
        },
    },
}

export default placements